import { iChrDeposit, iChrLaunch, iChrPeriod } from "../interfaces";

export class ChrDeposit {
	isWithdrawAvailable: boolean;
	// gainPercent: string;
	depositAmount: string;
	// fTokenAmount: string;	// not depositAmount
	// uTokenAmount: string;
	// depositDate: string;	// YYYY-MM-DD (purchase date) or '-'
	// purchasePrice: string;
	startPrice: string;
	period: number ;	// id
	launch: number | undefined = undefined;	// id

	// constructor (depositResponse: iChrDeposit, periods: iChrPeriod[], launches: iChrLaunch[]) {
	constructor (depositResponse: iChrDeposit, periods: iChrPeriod[]) {
		const foundPeriod = periods.find(period => {
			return period.id === depositResponse.per_id
		});

		this.period = depositResponse.per_id;
		if (foundPeriod) {
			this.launch = foundPeriod.launch_id;
	
			// this.isWithdrawAvailable = foundPeriod.state === 2 && this.launch < launches[launches.length-1].id;	// launch ended
			this.isWithdrawAvailable = foundPeriod.state === 2;
		} else {
			this.isWithdrawAvailable = false;
		}

		// const depositAmountBN = new BigNumber(depositResponse.depo_amt, {currentDecimals: 18})
		this.depositAmount = depositResponse.ft_amt_dec;

		// this.gainPercent = (new BigNumber(depositResponse.close_c, {currentDecimals: 18}).div( new BigNumber(depositResponse.c, {currentDecimals: 18})).sub('1')).mul(100);
		/* try{	// div can cause error
			this.gainPercent = toFixed( new BigNumber(depositResponse.close_c, {currentDecimals: 18})
				.div(depositResponse.c)
				.sub(1, {raiseValue: true})
				.mul(100, {raiseValue: true})
				.valueStr
			, 2);
			if (+this.gainPercent < 0) this.gainPercent = '0';
		} catch {
			// this.gainPercent = 'N/A'	// or change to zero?
			this.gainPercent = '0';	// or change to zero?
		} */

		// this.depositDate = this.isWithdrawAvailable? getHumanDate(+depositResponse.end_time, 'YYYY-MM-DD') : '-';

		// this.purchasePrice = this.isWithdrawAvailable? new BigNumber(depositResponse.l_ut_price, {currentDecimals: 18}).valueStr  : '-';

		this.startPrice = foundPeriod?.start_c || '1';	// fix

		/* if (this.isWithdrawAvailable){
			const t1 = depositAmountBN.mul(depositResponse.close_c).mul(depositResponse.l_ut_amt);
			const t2 = new BigNumber(depositResponse.c, {currentDecimals: 18}).mul(depositResponse.l_ft_amt);

			// const utInFt = +t1.valueBN18.mod(t2.valueBN18).toString() === 0
			const utInFt = t1.valueBN18.mod(t2.valueBN18).eq(new BigNumber('0').valueBN18)
				? t1.div(t2).mul(depositResponse.l_ut_price)
				: t1.div(t2).add(1).mul(depositResponse.l_ut_price)	// what is add 1
			;

			this.uTokenAmount = toFixed(t1.div(t2).valueStr, 4);
			this.fTokenAmount = toFixed(depositAmountBN.mul(depositResponse.close_c).div(depositResponse.c).sub(utInFt).valueStr, 4);
		} else {
			this.uTokenAmount = '0';
			this.fTokenAmount = toFixed(depositAmountBN.valueStr, 4);
		} */
	}
}